import { apiClient } from "~/api/ApiClient";
import { PAGE_TITLES } from "~/configs/pageTitles";

import ExportsPage from "../ExportsPage/ExportsPage";

const WorkDoneReports = () => (
  <ExportsPage
    exportType="WorkDoneReport"
    createFn={(siteId) => apiClient.sites.workDoneReportsCreate(siteId)}
    pageTitle={PAGE_TITLES.workDoneReports}
    description="Use this page to create and download spreadsheet files of all the work that has been completed for your site."
    successMessage="Work done report is generating"
    emptyText="Create your first work done report to get started."
  />
);

export default WorkDoneReports;
